module.exports = __webpack_public_path__ + "img/icon-prohibited_c.aea8e411.svg";